import React from "react";
// import { languages } from "../../constants/languages";
import EditPouleContainer from "../../containers/structure/EditPouleContainer";
import DeletePouleContainer from "../../containers/structure/DeletePouleContainer";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import PouleSpot from "./PouleSpot";
import List from "@material-ui/core/List";
import { Avatar } from "@material-ui/core";

const styles = (theme) => ({});

const StyledAvatar = withStyles({
  img: {
    height: "unset",
    borderRadius: 4,
  },
})(Avatar);

const Poule = (props) => (
  <Paper
    style={{
      marginBottom: 15,
      display: props.poule.losersFinal
        ? props.showLosersFinal
          ? "inline-block"
          : "none"
        : "inline-block",
      width: 220,
    }}
  >
    <div
      style={{
        background: props.theme.palette.primary.main,
        display: "flex",
        alignItems: "center",
        height: 30,
        paddingLeft: 10,
        borderRadius: "4px 4px 0px 0px",
      }}
    >
      <div
        variant="body2"
        style={{
          color: "white",
          fontWeight: 500,
          minWidth: 125,
          display: "flex",
          fontSize: "0.875rem",
        }}
      >
        {props.poule.showSponsor && props.poule.sponsorLogoURL && (
          <StyledAvatar
            variant="rounded"
            alt=""
            src={props.poule.sponsorLogoURL}
            style={{ height: 20, width: 20, marginRight: 5 }}
          />
        )}
        <span
          style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {props.poule.name +
            (props.poule.showSponsor && props.poule.sponsorName
              ? " - " + props.poule.sponsorName
              : "")}
        </span>
      </div>
      <div style={{ flex: "1 1 10%" }} />
      {(props.poule.doubleMatches || props.poule.numEncounters === 2) &&
        !(props.poule.numEncounters > 2) &&
        !(props.poule.numEncounters === 1) && (
          <div
            style={{
              backgroundColor: "rgb(255, 255, 255, .1)",
              borderRadius: 5,
              padding: "0px 5px",
              color: "white",
              fontWeight: 500,
              marginRight: 5,
            }}
          >
            x2
          </div>
        )}
      {props.poule.numEncounters > 2 && (
        <div
          style={{
            backgroundColor: "rgb(255, 255, 255, .1)",
            borderRadius: 5,
            padding: "0px 5px",
            color: "white",
            fontWeight: 500,
            marginRight: 5,
          }}
        >
          x{props.poule.numEncounters.toString()}
        </div>
      )}

      {!props.resultsPage && (
        <EditPouleContainer
          tournament={props.tournament}
          division={props.division}
          poule={props.poule}
          matches={props.matches}
          fase={props.fase}
          resultSpotsNotDivided={props.resultSpotsNotDivided}
          teams={props.teams}
          singleMatch={props.poule.singleMatch}
          belongsToBracket={props.belongsToBracket}
          userStatus={props.userStatus}
          tournamentStatus={props.tournamentStatus}
          toggleFinishedDialog={props.toggleFinishedDialog}
          user={props.user || {}}
          poulesByKey={props.poulesByKey}
          daysByKey={props.daysByKey}
          toggleUpgradeDialog={props.toggleUpgradeDialog}
          bracketsByKey={props.bracketsByKey}
        />
      )}
      {!props.resultsPage && (
        <DeletePouleContainer
          tournament={props.tournament}
          poule={props.poule}
          teams={props.teams}
          matches={props.matches}
          resultSpotsNotDivided={props.resultSpotsNotDivided}
          onRef={props.onRef}
          singleMatch={props.poule.singleMatch}
          belongsToBracket={props.belongsToBracket}
          toggleLosersFinal={props.toggleLosersFinal}
          tournamentStatus={props.tournamentStatus}
          toggleFinishedDialog={props.toggleFinishedDialog}
          daysByKey={props.daysByKey}
        />
      )}
    </div>
    {/* <div
      style={{
        background: "#e3e4e4",
        color: "#5d5c5c",
        display: "flex",
        alignItems: "center",
        height: 25,
        paddingLeft: 10,
        fontSize: 13,
        marginBottom: 5
      }}
    >
      {props.matches.length +
        " " +
        (props.matches.length === 1
          ? languages.structure.match
          : languages.structure.matches)}
      {props.poule.doubleMatches && " (" + languages.structure.double + ")"}
    </div> */}
    <div
      style={{
        whiteSpace: "nowrap",
        overflowX: "auto",
        overflowY: "hidden",
      }}
    >
      <List style={{ padding: 0 }}>
        {props.teams.map((team) => {
          return (
            <PouleSpot
              key={team.id}
              team={team}
              tournament={props.tournament}
              teams={props.teams}
              handleClickPouleSpot={props.handleClickPouleSpot}
              poule={props.poule}
              toggleResultSpotType={props.toggleResultSpotType}
              bracket={props.bracket}
              teamsLoaded={props.teamsLoaded}
              resultSpotsLoaded={props.resultSpotsLoaded}
              resultsPage={props.resultsPage}
            />
          );
        })}
      </List>
    </div>
  </Paper>
);

Poule.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles, { withTheme: true })(Poule);
